import { HSConfiguration } from './HSConfiguration';

export class FoldingDoorConfiguration extends HSConfiguration {
    type: 'folding_door' = 'folding_door';
}
